let clientConfig;

if (process.env.REACT_APP_CLIENT) {
    const client = process.env.REACT_APP_CLIENT
    clientConfig = require(`client/${client}/conf`);
} else {
  console.error("set REACT_APP_CLIENT env variable");
}

module.exports = clientConfig;
